import { useTranslation } from 'react-i18next';
import { Button } from 'components/buttons';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'components/dialog/dialog';

interface ReauthRequiredDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
}

export const ReauthRequiredDialog = ({ isOpen, onConfirm }: ReauthRequiredDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onConfirm()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('login.reauth_required_title')}</DialogTitle>
          <DialogDescription>{t('login.reauth_required_message')}</DialogDescription>
        </DialogHeader>
        <Button onClick={onConfirm} className="w-full">
          {t('login.reauth_required_action')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
